module.exports = __webpack_public_path__ + "img/cornerRightBottom.25ac533c.svg";